import React from 'react'
import { mdiDelete, mdiLinkVariant, mdiPencil } from '@mdi/js'
import { CircleSpinner } from 'react-spinners-kit'
import List, { ListColumn, ListOption, ListRow, ListSection } from '../../../../components/List'
import { LinksTutoriaisItemType } from '../types'

interface Props {
    lista: LinksTutoriaisItemType[] | null
    loading: boolean
    canEdit: boolean
    onEditar: (item: LinksTutoriaisItemType) => void
    onRemover: (item: LinksTutoriaisItemType) => void
}

const TableListarItens: React.FC<Props> = ({ lista, loading, canEdit, onEditar, onRemover }) => {
    const SHOW_LOADING = loading
    const SHOW_TABLE = !!lista && !SHOW_LOADING
    const grid = "150px 1fr 150px 70px"

    const abrirLink = (url: string) => {
        let link = url.trim()
        if (!link.startsWith('http://') && !link.startsWith('https://')) {
            link = `https://${link}`
        }
        window.open(link, '_blank', 'noopener,noreferrer')
    }

    return (
        <List name="list">
            <ListSection type="header">
                <ListRow grid={grid}>
                    {["Assunto", "Link", "Responsável", "Opções"].map((col, index) => (
                        <ListColumn key={index}>{col}</ListColumn>
                    ))}
                </ListRow>
            </ListSection>
            <ListSection type="main">
                {SHOW_LOADING && (
                    <ListRow grid="1fr">
                        <ListColumn center><CircleSpinner size={32} color="grey" /></ListColumn>
                    </ListRow>
                )}
                {SHOW_TABLE && lista.length === 0 && (
                    <ListRow grid="1fr">
                        <ListColumn center>Nenhum link cadastrado nesta lista.</ListColumn>
                    </ListRow>
                )}
                {SHOW_TABLE && lista.map((item, index) => (
                    <ListRow key={item.id} zebra={index % 2 === 0} grid={grid}>
                        <ListColumn>{item.assunto}</ListColumn>
                        <ListColumn >
                            {item.link && (
                                <> {item.link} 
                                <ListOption
                                    icon={mdiLinkVariant}
                                    tooltip={item.link}
                                    onClick={() => abrirLink(item.link)}
                                />
                                </>
                            ) || <>Link não cadastrado</>}
                        </ListColumn>
                        <ListColumn>{item.nomeResponsavel}</ListColumn>
                        <ListColumn>
                            {canEdit && (
                                <>
                                    <ListOption icon={mdiPencil} onClick={() => onEditar(item)} />
                                    <ListOption icon={mdiDelete} status="error" onClick={() => onRemover(item)} />
                                </>
                            )}
                        </ListColumn>
                    </ListRow>
                ))}
            </ListSection>
        </List>
    )
}

export default TableListarItens
